const RootPath = window.g.baseUrl
const apis = {
  /* 板块 api */
  // 包装票据列表
  getPackageNoteList: RootPath + 'plugin/plate/packagenote/GetPackageNoteList',
  // 包装明细，从生产数据库
  getPackageDetail: RootPath + 'plugin/plate/packagenote/getPackageDetail',

  getPackageCollectionId: RootPath + 'plugin/plate/packagenote/GetPackageCollectionId',

  insertExcelData: RootPath + 'plugin/plate/packagenote/InsertExcelData',

  getundertakeList: RootPath + 'plugin/plate/packagenote/GetundertakeList',

  delundertake: RootPath + 'plugin/plate/packagenote/Delundertake',

  delUnderTakes: RootPath + 'plugin/plate/packagenote/DelUnderTakes',

  getUnderTakeProducts: RootPath + 'plugin/plate/packagenote/GetUnderTakeProducts',

  delSampleName: RootPath + 'plugin/plate/packagenote/DelSampleName',
  
  // 打印库位码
  getPrintPositionList: RootPath + 'plugin/plate/packagenote/GetPrintPositionList',

  getMaterialSummaryList: RootPath + 'plugin/plate/packagenote/GetMaterialSummaryList',
  // 优化后
  getMaterialSummaryList1: RootPath + 'plugin/plate/packagenote/GetMaterialSummaryList1',

  getMaterialDetailData: RootPath + 'plugin/plate/packagenote/GetMaterialDetailData',

  exportMaterialSummaryList: RootPath + 'plugin/plate/packagenote/ExportMaterialSummaryList',
  // 优化后
  exportMaterialSummaryList1: RootPath + 'plugin/plate/packagenote/ExportMaterialSummaryList1',

  getMaterialPositionList: RootPath + 'plugin/plate/packagenote/GetMaterialPositionList',

  getStorePositionList: RootPath + 'plugin/plate/packagenote/GetStorePositionList',

  //出入库明细
  getOutInStoreDetailList: RootPath + 'plugin/plate/packagenote/GetOutInStoreDetailList',
  exportOutInList: RootPath + 'plugin/plate/packagenote/exportOutInList',

  // 二楼搜索
  getTwoFloorList: RootPath + 'plugin/plate/packagenote/GetTwoFloorList',

  // 三楼搜索
  getThreeFloorList: RootPath + 'plugin/plate/packagenote/GetThreeFloorList',

  delCollection: RootPath + 'plugin/plate/packagenote/DelCollection',
  // 根据笼号获取是否有在用的库存
  getStoreIsUse: RootPath + 'plugin/plate/packagenote/getStoreIsUse',
}

export default apis
